export default __webpack_public_path__ + "static/media/art-0-waste2.8899c707.jpeg";